import Car3GridContainer from "../../../components/car/grid/Car3Grid";

const Car3Grid = () => {
  return <Car3GridContainer />;
};

export default Car3Grid;
